import React, { useState } from 'react';
import { Alert, Tag } from 'antd';
import { ExperimentOutlined, CloseOutlined } from '@ant-design/icons';

interface DemoBannerProps {
  showTopBanner?: boolean;
  showFloatingBadge?: boolean;
}

const DemoBanner: React.FC<DemoBannerProps> = ({
  showTopBanner = true,
  showFloatingBadge = true
}) => {
  const [bannerVisible, setBannerVisible] = useState(true);

  return (
    <>
      {/* 顶部横幅 - 醒目的演示环境提示 */}
      {showTopBanner && bannerVisible && (
        <Alert
          message={
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <ExperimentOutlined style={{ fontSize: 18, marginRight: 8 }} />
              <strong>デモ環境</strong>
              <span style={{ marginLeft: 8 }}>
                これはデモ版です。表示されているデータはサンプルです。
              </span>
            </div>
          }
          type="warning"
          banner
          closable
          onClose={() => setBannerVisible(false)}
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 1000,
            textAlign: 'center',
            borderRadius: 0,
            marginBottom: 0,
          }}
        />
      )}

      {/* 右上角浮动徽章 */}
      {showFloatingBadge && (
        <div
          style={{
            position: 'fixed',
            top: 80,
            right: 20,
            zIndex: 999,
            transform: 'rotate(0deg)',
          }}
        >
          <Tag
            color="orange"
            style={{
              fontSize: 16,
              padding: '8px 16px',
              borderRadius: 8,
              boxShadow: '0 4px 12px rgba(250, 140, 22, 0.4)',
              border: '2px solid #fa8c16',
              fontWeight: 'bold',
              letterSpacing: 2,
              animation: 'pulse 2s infinite',
            }}
          >
            <ExperimentOutlined style={{ marginRight: 4 }} />
            DEMO
          </Tag>
        </div>
      )}

      {/* CSS动画 */}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 4px 12px rgba(250, 140, 22, 0.4);
          }
          50% {
            transform: scale(1.05);
            box-shadow: 0 6px 16px rgba(250, 140, 22, 0.6);
          }
        }
      `}</style>
    </>
  );
};

export default DemoBanner;
